import React, { useState } from "react";
import "./NavBar.css";
import TextAnimation from "react-text-animations";
import { Link } from "react-router-dom";

function NavBar() {
  const [openbtn, setopenbtn] = useState(false);
  const [drop, setdrop] = useState(true)
  const [drop1, setdrop1] = useState(true)

  const [drops, setdrops] = useState(true)

  return (
    <>

{/* desktop navbar ############# */}


      <nav class="navbar navbar-div1 navbar-expand-lg navbar-light ">
        <div>
          <Link to='/'>
          <TextAnimation.Slide
            target="QASIM"
            text={["QASIM", "DESIGNER"]}
            cname="desk-logo-text2"
            animation={{
              duration: 1000,
              delay: 2000,
              timingFunction: "ease-out",
            }}
          >
            IAM QASIM
          </TextAnimation.Slide>
          </Link>
       </div>

        <div
          class="collapse navbar-collapse justify-content-center"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav desk-navbar-ul ">

            <li className="nav-item active desk-nav-li1" >
              <Link
                class="nav-link"
                to="/"
              >
                Home
              </Link>
            </li>

            <li className="nav-item active desk-nav-li1" >
              <Link
                class="nav-link"
                to="/about"
              >
                About Us
              </Link>
            </li>

            <li className="nav-item active desk-nav-li1" >
              <Link
                class="nav-link"
                to="/works"
              >
                All Work
              </Link>
            </li>


            <li className="nav-item active desk-nav-li1 dropdown" >
              <a
                class="nav-link dropdown-toggle"
                href="#" role="button" aria-expanded="false"
                onClick={() => { setdrop1(!drop1); setdrops(true); setdrop(true) }}
              >
                Services
              </a>
              <div class={`${drop1 === true ? "dropdown-menu dropdown-menu-div" : "dropdown-menu dropdown-menu-div show"}`}>
                <div className="dropdown-item-div1">
                  <Link to="/webdesign" class="dropdown-item dropdown-item-text" ><svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="F0F2F5" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Website Design</Link>
                </div>
                <div class="dropdown-divider mx-auto"></div>
                <div className="dropdown-item-div1">
                  <Link class="dropdown-item dropdown-item-text" to="/uidesign"> <svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    UI/UX Design</Link>
                </div>
              </div>
            </li>

            <li className="nav-item active desk-nav-li1 dropdown" >
              <a
                class="nav-link dropdown-toggle"
                href="#" role="button" aria-expanded="false"
                onClick={() => { setdrop(!drop); setdrops(true); setdrop1(true)  }}
              >
                Figma Folio
              </a>
              <div class={`${drop === true ? "dropdown-menu dropdown-menu-div" : "dropdown-menu dropdown-menu-div show"}`}>
                <div className="dropdown-item-div1">
                  <a href="https://www.figma.com/file/ZtxXHtoGYEE5KysqrUmblp/Web-UI-UX" target="_blank" class="dropdown-item dropdown-item-text" ><svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="F0F2F5" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Web UI/UX</a>
                </div>
                <div class="dropdown-divider mx-auto"></div>
                <div className="dropdown-item-div1">
                  <a class="dropdown-item dropdown-item-text" href="https://www.figma.com/file/dRd1xglL5pPSzEahkEMKlW/Mobile-UI-UX" target="_blank"> <svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Mobile UI/UX</a>
                </div>
              </div>
            </li>

            

            <li className="nav-item active desk-nav-li1" >
              <Link
                class="nav-link"
                to="/contact"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div className='d-flex  justify-content-end icons-div11'>
          <div>
            <a href='mailto:hellomqasim@gmail.com'>
              <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                <circle cx="16.545" cy="16.545" r="16.545" fill="#101118" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 11C8.89543 11 8 11.8954 8 13V22C8 23.1046 8.89543 24 10 24H24C25.1046 24 26 23.1046 26 22V13C26 11.8954 25.1046 11 24 11H10ZM24.1604 13.1444C23.964 12.7797 23.5091 12.6433 23.1444 12.8396L17 16.1482L10.8556 12.8396C10.4909 12.6433 10.036 12.7797 9.83965 13.1444C9.64327 13.5091 9.77972 13.964 10.1444 14.1604L16.6444 17.6604C16.8664 17.7799 17.1336 17.7799 17.3556 17.6604L23.8556 14.1604C24.2203 13.964 24.3567 13.5091 24.1604 13.1444Z" fill="#B3B6BE" />
              </svg>
            </a>
          </div>

          <div>
            <a href='https://www.instagram.com/i.am.qasim' target='_blank'>
              <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                <circle cx="16.5" cy="16.5" r="14.5" fill="#B3B6BE" />
                <path d="M16.5465 0.137695C7.35402 0.137695 0 7.49171 0 16.6842C0 25.8768 7.35402 33.2308 16.5465 33.2308C25.7391 33.2308 33.0931 25.8768 33.0931 16.6842C33.0931 7.49171 25.7391 0.137695 16.5465 0.137695ZM16.5465 13.0072C18.5689 13.0072 20.2235 14.6619 20.2235 16.6842C20.2235 18.7066 18.5689 20.3612 16.5465 20.3612C14.5242 20.3612 12.8695 18.7066 12.8695 16.6842C12.8695 14.6619 14.5242 13.0072 16.5465 13.0072ZM21.6943 9.33022C21.6943 8.04326 22.7974 7.12401 23.9006 7.12401C25.0037 7.12401 26.1068 8.22711 26.1068 9.33022C26.1068 10.4333 25.1875 11.5364 23.9006 11.5364C22.6136 11.5364 21.6943 10.6172 21.6943 9.33022ZM16.5465 29.5538C9.37637 29.5538 3.67701 23.8544 3.67701 16.6842H9.19252C9.19252 20.7289 12.5018 24.0382 16.5465 24.0382C20.5912 24.0382 23.9006 20.7289 23.9006 16.6842H29.4161C29.4161 23.8544 23.7167 29.5538 16.5465 29.5538Z" fill="#101118" />
              </svg>
            </a>
          </div>
          <div>
            <a href='https://www.behance.net/iamqasim' target='_blank'>
              <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                <path d="M17.5502 34.0312C26.9476 34.0312 34.5658 26.4131 34.5658 17.0156C34.5658 7.61815 26.9476 0 17.5502 0C8.1527 0 0.534546 7.61815 0.534546 17.0156C0.534546 26.4131 8.1527 34.0312 17.5502 34.0312Z" fill="#101118" />
                <path d="M12.5543 9.30566C13.288 9.30566 13.9578 9.371 14.5635 9.50032C15.1693 9.62964 15.6865 9.842 16.1181 10.1374C16.5496 10.4328 16.8844 10.8248 17.1227 11.3149C17.3609 11.8049 17.4793 12.4093 17.4793 13.1294C17.4793 13.9067 17.3023 14.5546 16.9498 15.0733C16.5972 15.5919 16.0745 16.0166 15.3843 16.3474C16.3345 16.621 17.0437 17.1002 17.512 17.7835C17.9803 18.4669 18.2144 19.2918 18.2144 20.2569C18.2144 21.0342 18.0633 21.708 17.7611 22.277C17.4589 22.846 17.0519 23.3102 16.54 23.6696C16.0282 24.0303 15.4456 24.2957 14.7908 24.4686C14.132 24.6415 13.4527 24.7286 12.7721 24.7273H5.29749V9.30566H12.5543ZM12.1228 15.547C12.7272 15.547 13.224 15.4027 13.6134 15.1155C14.0027 14.8269 14.1973 14.36 14.196 13.712C14.196 13.3527 14.1306 13.0573 14.0013 12.8272C13.872 12.5972 13.6991 12.4161 13.4827 12.2868C13.2662 12.1575 13.0185 12.0676 12.7381 12.0173C12.4495 11.9669 12.1568 11.941 11.8628 11.9424H8.68972V15.5497L12.1228 15.547ZM12.3175 22.0905C12.6373 22.0919 12.9559 22.0592 13.2676 21.9939C13.5698 21.9285 13.8366 21.821 14.0667 21.6699C14.2967 21.5188 14.4805 21.3133 14.618 21.0546C14.7541 20.796 14.8235 20.4638 14.8235 20.0609C14.8235 19.27 14.6003 18.7037 14.1538 18.3661C13.7073 18.0272 13.1165 17.8584 12.3828 17.8584H8.68972V22.0919L12.3175 22.0905ZM22.4805 21.7665C22.9406 22.213 23.6036 22.4363 24.468 22.4363C25.0873 22.4363 25.6196 22.2811 26.0661 21.9721C26.5126 21.6631 26.7862 21.335 26.8869 20.9893H29.5863C29.1548 22.3287 28.4918 23.2857 27.5988 23.8615C26.7059 24.4373 25.6264 24.7259 24.3591 24.7259C23.4811 24.7259 22.6888 24.5857 21.9837 24.3053C21.2786 24.0249 20.681 23.6247 20.1909 23.106C19.7009 22.5874 19.3224 21.9694 19.057 21.2493C18.7916 20.5292 18.6582 19.7369 18.6582 18.8739C18.6582 18.0394 18.7943 17.2622 19.0679 16.5421C19.3415 15.822 19.7308 15.1999 20.2345 14.6744C20.7381 14.149 21.3398 13.7352 22.0381 13.433C22.7365 13.1308 23.511 12.9797 24.3604 12.9797C25.3106 12.9797 26.1382 13.1634 26.8447 13.531C27.5498 13.8985 28.1297 14.3913 28.583 15.0107C29.0363 15.63 29.3644 16.3352 29.5659 17.1274C29.7673 17.9197 29.8395 18.7473 29.7823 19.6117H21.7264C21.7686 20.6013 22.0204 21.3214 22.4805 21.7665ZM25.9476 15.8928C25.5801 15.4898 25.022 15.2884 24.2733 15.2884C23.7833 15.2884 23.3762 15.3714 23.0536 15.5361C22.7297 15.7022 22.471 15.9064 22.2764 16.1514C22.0817 16.3964 21.9456 16.6551 21.8666 16.9287C21.7877 17.2023 21.74 17.4473 21.7264 17.6624H26.7154C26.5697 16.8865 26.3138 16.2957 25.9476 15.8928ZM21.201 10.0884H27.4341V11.8172H21.201V10.0884Z" fill="#B3B6BE" />
              </svg>
            </a>
          </div>

          <div>
            <a href='https://dribbble.com/imqasim' target='_blank'>
              <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                <path d="M16.9751 1.23608C25.5069 1.23608 32.4099 8.13909 32.4099 16.658C32.4099 25.1769 25.5069 32.0928 16.9751 32.0928C8.44329 32.0928 1.54028 25.1898 1.54028 16.6709C1.54028 8.15202 8.44329 1.23608 16.9751 1.23608Z" fill="#B3B6BE" />
                <path d="M16.9762 33.192C7.84977 33.192 0.429688 25.7848 0.429688 16.6713C0.429688 7.54486 7.84977 0.137695 16.9762 0.137695C26.1027 0.137695 33.5228 7.54486 33.5228 16.6584C33.5228 25.7719 26.1027 33.192 16.9762 33.192ZM30.9244 18.9206C30.4461 18.7655 26.5551 17.615 22.1212 18.313C23.9697 23.3804 24.7195 27.517 24.8617 28.3702C28.0417 26.2373 30.3039 22.8504 30.9244 18.9206ZM22.496 29.6758C22.2892 28.4349 21.4619 24.1172 19.4841 18.9723C19.4582 18.9852 19.4194 18.9982 19.3936 18.9982C11.4176 21.7775 8.56076 27.2973 8.30222 27.8144C10.6937 29.6758 13.7057 30.7876 16.9762 30.7876C18.9282 30.8005 20.8026 30.3998 22.496 29.6758ZM6.47951 26.1209C6.80269 25.578 10.6808 19.1662 17.9716 16.8006C18.1526 16.7359 18.3465 16.6842 18.5275 16.6325C18.1784 15.831 17.7906 15.0296 17.377 14.241C10.3188 16.3481 3.46753 16.2576 2.84703 16.2447C2.84703 16.3869 2.83411 16.5291 2.83411 16.6713C2.84703 20.3038 4.21729 23.6131 6.47951 26.1209ZM3.14435 13.7886C3.77778 13.8015 9.59492 13.8274 16.2135 12.0693C13.8737 7.90681 11.3401 4.41653 10.9781 3.91237C7.00952 5.77386 4.06217 9.41927 3.14435 13.7886ZM13.6669 2.95578C14.0547 3.47286 16.6272 6.96314 18.9411 11.2161C23.9697 9.32878 26.0897 6.48484 26.3483 6.12289C23.8534 3.91237 20.5699 2.56797 16.9762 2.56797C15.8386 2.56797 14.7269 2.71016 13.6669 2.95578ZM27.9124 7.75169C27.6151 8.15242 25.2495 11.1903 20.027 13.3232C20.3502 13.9954 20.6733 14.6805 20.9707 15.3657C21.0741 15.6113 21.1775 15.8569 21.2809 16.0896C25.9863 15.4949 30.653 16.4515 31.1183 16.542C31.0796 13.2198 29.8903 10.1561 27.9124 7.75169Z" fill="#101118" />
              </svg>
            </a>
          </div>
        </div>


      </nav>










    {/* mobile navbar #######  */}

      <div className="container-fluid navbar-div1 d-none ">
        <div id="myNav" className={`${openbtn ? "overlay" : "overlay1"}`}>
          <div>
            <Link to='/'>
            <TextAnimation.Slide
              target="QASIM"
              text={["QASIM", "DESIGNER"]}
              cname="logo-text1"
              animation={{
                duration: 1000,
                delay: 2000,
                timingFunction: "ease-out",
              }}
            >
              IAM QASIM
            </TextAnimation.Slide>
            </Link>
          </div>
          <a
            href="javascript:void(0)"
            class="closebtn"
            onClick={() => {
              setopenbtn(!openbtn);
            }}
          >
            &times;
          </a>
          <div class="overlay-content">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-12 nav-text-div1 ">
                  <Link
                    to="/"
                    className=" nav-text1"
                    onClick={() => {
                      setopenbtn(!openbtn);
                    }}
                  >
                    Home <span>01</span>
                  </Link>

                  <Link
                    to="/about"
                    className=" nav-text1"
                    onClick={() => {
                      setopenbtn(!openbtn);
                    }}
                  >
                    About <span>02</span>
                  </Link>
                  <Link
                    to="/works"
                    className=" nav-text1"
                    onClick={() => {
                      setopenbtn(!openbtn);
                    }}
                  >
                    Works <span>03</span>
                  </Link>
                </div>
                <div className="col-lg-6 col-12  nav-text-div1">
                  <Link to='/webdesign'
                    // href="https://www.figma.com/file/ZtxXHtoGYEE5KysqrUmblp/Web-UI-UX" target="_blank"
                    className=" nav-text1"
                    onClick={() => {
                      setopenbtn(!openbtn);
                    }}
                  >
                    Website Design <span>04</span>
                  </Link>
                  <Link to='/uidesign'
                    // href="https://www.figma.com/file/dRd1xglL5pPSzEahkEMKlW/Mobile-UI-UX" target="_blank"
                    className=" nav-text1"
                    onClick={() => {
                      setopenbtn(!openbtn);
                    }}
                  >  
                    UI/UX Design<span>05</span>
                  </Link>
                  <Link
                    to="/contact"
                    className=" nav-text1"
                    onClick={() => {
                      setopenbtn(!openbtn);
                    }}
                  >
                    Contact <span>06</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" d-flex align-items-center mt-1 ">
          <span
            className="navbar-btn1  "
            onClick={() => {
              setopenbtn(!openbtn);
            }}
          >
            &#9776;{" "}
          </span>
        </div>

        <div>
          <Link to='/'>
          <TextAnimation.Slide
            target="QASIM"
            text={["QASIM", "DESIGNER"]}
            cname="logo-text2"
            animation={{
              duration: 1000,
              delay: 2000,
              timingFunction: "ease-out",
            }}
          >
            IAM QASIM
          </TextAnimation.Slide>
          </Link>
       </div>

        <div className='d-flex  justify-content-end icons-div11'>
          <div>
            <a href='mailto:weeqasim@gmail.com'>
              <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                <circle cx="16.545" cy="16.545" r="16.545" fill="#101118" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 11C8.89543 11 8 11.8954 8 13V22C8 23.1046 8.89543 24 10 24H24C25.1046 24 26 23.1046 26 22V13C26 11.8954 25.1046 11 24 11H10ZM24.1604 13.1444C23.964 12.7797 23.5091 12.6433 23.1444 12.8396L17 16.1482L10.8556 12.8396C10.4909 12.6433 10.036 12.7797 9.83965 13.1444C9.64327 13.5091 9.77972 13.964 10.1444 14.1604L16.6444 17.6604C16.8664 17.7799 17.1336 17.7799 17.3556 17.6604L23.8556 14.1604C24.2203 13.964 24.3567 13.5091 24.1604 13.1444Z" fill="#B3B6BE" />
              </svg>
            </a>
          </div>

          <div>
            <a href='https://www.instagram.com/i.am.qasim' target='_blank'>
<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
              <circle cx="16.5" cy="16.5" r="14.5" fill="#B3B6BE" />
              <path d="M16.5465 0.137695C7.35402 0.137695 0 7.49171 0 16.6842C0 25.8768 7.35402 33.2308 16.5465 33.2308C25.7391 33.2308 33.0931 25.8768 33.0931 16.6842C33.0931 7.49171 25.7391 0.137695 16.5465 0.137695ZM16.5465 13.0072C18.5689 13.0072 20.2235 14.6619 20.2235 16.6842C20.2235 18.7066 18.5689 20.3612 16.5465 20.3612C14.5242 20.3612 12.8695 18.7066 12.8695 16.6842C12.8695 14.6619 14.5242 13.0072 16.5465 13.0072ZM21.6943 9.33022C21.6943 8.04326 22.7974 7.12401 23.9006 7.12401C25.0037 7.12401 26.1068 8.22711 26.1068 9.33022C26.1068 10.4333 25.1875 11.5364 23.9006 11.5364C22.6136 11.5364 21.6943 10.6172 21.6943 9.33022ZM16.5465 29.5538C9.37637 29.5538 3.67701 23.8544 3.67701 16.6842H9.19252C9.19252 20.7289 12.5018 24.0382 16.5465 24.0382C20.5912 24.0382 23.9006 20.7289 23.9006 16.6842H29.4161C29.4161 23.8544 23.7167 29.5538 16.5465 29.5538Z" fill="#101118" />
            </svg>
            </a>
          </div>
          <div>
            <a href='https://www.behance.net/iamqasim'  target='_blank'>
              <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                <path d="M17.5502 34.0312C26.9476 34.0312 34.5658 26.4131 34.5658 17.0156C34.5658 7.61815 26.9476 0 17.5502 0C8.1527 0 0.534546 7.61815 0.534546 17.0156C0.534546 26.4131 8.1527 34.0312 17.5502 34.0312Z" fill="#101118" />
                <path d="M12.5543 9.30566C13.288 9.30566 13.9578 9.371 14.5635 9.50032C15.1693 9.62964 15.6865 9.842 16.1181 10.1374C16.5496 10.4328 16.8844 10.8248 17.1227 11.3149C17.3609 11.8049 17.4793 12.4093 17.4793 13.1294C17.4793 13.9067 17.3023 14.5546 16.9498 15.0733C16.5972 15.5919 16.0745 16.0166 15.3843 16.3474C16.3345 16.621 17.0437 17.1002 17.512 17.7835C17.9803 18.4669 18.2144 19.2918 18.2144 20.2569C18.2144 21.0342 18.0633 21.708 17.7611 22.277C17.4589 22.846 17.0519 23.3102 16.54 23.6696C16.0282 24.0303 15.4456 24.2957 14.7908 24.4686C14.132 24.6415 13.4527 24.7286 12.7721 24.7273H5.29749V9.30566H12.5543ZM12.1228 15.547C12.7272 15.547 13.224 15.4027 13.6134 15.1155C14.0027 14.8269 14.1973 14.36 14.196 13.712C14.196 13.3527 14.1306 13.0573 14.0013 12.8272C13.872 12.5972 13.6991 12.4161 13.4827 12.2868C13.2662 12.1575 13.0185 12.0676 12.7381 12.0173C12.4495 11.9669 12.1568 11.941 11.8628 11.9424H8.68972V15.5497L12.1228 15.547ZM12.3175 22.0905C12.6373 22.0919 12.9559 22.0592 13.2676 21.9939C13.5698 21.9285 13.8366 21.821 14.0667 21.6699C14.2967 21.5188 14.4805 21.3133 14.618 21.0546C14.7541 20.796 14.8235 20.4638 14.8235 20.0609C14.8235 19.27 14.6003 18.7037 14.1538 18.3661C13.7073 18.0272 13.1165 17.8584 12.3828 17.8584H8.68972V22.0919L12.3175 22.0905ZM22.4805 21.7665C22.9406 22.213 23.6036 22.4363 24.468 22.4363C25.0873 22.4363 25.6196 22.2811 26.0661 21.9721C26.5126 21.6631 26.7862 21.335 26.8869 20.9893H29.5863C29.1548 22.3287 28.4918 23.2857 27.5988 23.8615C26.7059 24.4373 25.6264 24.7259 24.3591 24.7259C23.4811 24.7259 22.6888 24.5857 21.9837 24.3053C21.2786 24.0249 20.681 23.6247 20.1909 23.106C19.7009 22.5874 19.3224 21.9694 19.057 21.2493C18.7916 20.5292 18.6582 19.7369 18.6582 18.8739C18.6582 18.0394 18.7943 17.2622 19.0679 16.5421C19.3415 15.822 19.7308 15.1999 20.2345 14.6744C20.7381 14.149 21.3398 13.7352 22.0381 13.433C22.7365 13.1308 23.511 12.9797 24.3604 12.9797C25.3106 12.9797 26.1382 13.1634 26.8447 13.531C27.5498 13.8985 28.1297 14.3913 28.583 15.0107C29.0363 15.63 29.3644 16.3352 29.5659 17.1274C29.7673 17.9197 29.8395 18.7473 29.7823 19.6117H21.7264C21.7686 20.6013 22.0204 21.3214 22.4805 21.7665ZM25.9476 15.8928C25.5801 15.4898 25.022 15.2884 24.2733 15.2884C23.7833 15.2884 23.3762 15.3714 23.0536 15.5361C22.7297 15.7022 22.471 15.9064 22.2764 16.1514C22.0817 16.3964 21.9456 16.6551 21.8666 16.9287C21.7877 17.2023 21.74 17.4473 21.7264 17.6624H26.7154C26.5697 16.8865 26.3138 16.2957 25.9476 15.8928ZM21.201 10.0884H27.4341V11.8172H21.201V10.0884Z" fill="#B3B6BE" />
              </svg>
            </a>
          </div>

          <div>
            <a href='https://dribbble.com/imqasim' target='_blank'>
              <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                <path d="M16.9751 1.23608C25.5069 1.23608 32.4099 8.13909 32.4099 16.658C32.4099 25.1769 25.5069 32.0928 16.9751 32.0928C8.44329 32.0928 1.54028 25.1898 1.54028 16.6709C1.54028 8.15202 8.44329 1.23608 16.9751 1.23608Z" fill="#B3B6BE" />
                <path d="M16.9762 33.192C7.84977 33.192 0.429688 25.7848 0.429688 16.6713C0.429688 7.54486 7.84977 0.137695 16.9762 0.137695C26.1027 0.137695 33.5228 7.54486 33.5228 16.6584C33.5228 25.7719 26.1027 33.192 16.9762 33.192ZM30.9244 18.9206C30.4461 18.7655 26.5551 17.615 22.1212 18.313C23.9697 23.3804 24.7195 27.517 24.8617 28.3702C28.0417 26.2373 30.3039 22.8504 30.9244 18.9206ZM22.496 29.6758C22.2892 28.4349 21.4619 24.1172 19.4841 18.9723C19.4582 18.9852 19.4194 18.9982 19.3936 18.9982C11.4176 21.7775 8.56076 27.2973 8.30222 27.8144C10.6937 29.6758 13.7057 30.7876 16.9762 30.7876C18.9282 30.8005 20.8026 30.3998 22.496 29.6758ZM6.47951 26.1209C6.80269 25.578 10.6808 19.1662 17.9716 16.8006C18.1526 16.7359 18.3465 16.6842 18.5275 16.6325C18.1784 15.831 17.7906 15.0296 17.377 14.241C10.3188 16.3481 3.46753 16.2576 2.84703 16.2447C2.84703 16.3869 2.83411 16.5291 2.83411 16.6713C2.84703 20.3038 4.21729 23.6131 6.47951 26.1209ZM3.14435 13.7886C3.77778 13.8015 9.59492 13.8274 16.2135 12.0693C13.8737 7.90681 11.3401 4.41653 10.9781 3.91237C7.00952 5.77386 4.06217 9.41927 3.14435 13.7886ZM13.6669 2.95578C14.0547 3.47286 16.6272 6.96314 18.9411 11.2161C23.9697 9.32878 26.0897 6.48484 26.3483 6.12289C23.8534 3.91237 20.5699 2.56797 16.9762 2.56797C15.8386 2.56797 14.7269 2.71016 13.6669 2.95578ZM27.9124 7.75169C27.6151 8.15242 25.2495 11.1903 20.027 13.3232C20.3502 13.9954 20.6733 14.6805 20.9707 15.3657C21.0741 15.6113 21.1775 15.8569 21.2809 16.0896C25.9863 15.4949 30.653 16.4515 31.1183 16.542C31.0796 13.2198 29.8903 10.1561 27.9124 7.75169Z" fill="#101118" />
              </svg>
            </a>
          </div>
        </div>

      </div>
    </>
  );
}

export default NavBar;
